import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import NotificationsOutlinedIcon from "@material-ui/icons/NotificationsOutlined";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Logo from "../../contents/img/Rampver Online Logo Square.png";
import LogoMobile from "../../contents/img/Rampver-Online-Logo-(Long).png";
import { withFirebase } from "../Firebase";
import {
  DashboardOutlined,
  HistoryOutlined,
  PieChartOutlined,
  Schedule,
} from "@material-ui/icons";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import * as ROUTES from "../../constants/route";
import NotificationMenu from "../NotificationMenu";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import Footer from "../Footer";
import Fab from "@material-ui/core/Fab";
import { orange } from "@material-ui/core/colors";
import { Button, Tooltip } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { COLOR_PRIMARY } from "../../constants/colors";
import { AuthUserContext } from "../Session";
import { useAttestationEligibility } from "../VideoAttestation/useAttestationEligibility";
import { useFundEligibility } from "../../hooks/useFundEligibility";
import { getApplicableInvestmentMinimum, getInvestmentEligibilityMessage } from "../MyInvestments/investmentEligibility";

const drawerWidth = 240;
const LONG_KYC_PENDING_STATUSES = [
  "LONG_KYC-2", "LONG_KYC-3", "LONG_KYC-5", "LONG_KYC-6", "LONG_KYC-7",
  "LONG_KYC-9", "LONG_KYC-10", "LONG_KYC-11", "LONG_KYC-12",
];
const EMPTY_KYC_ATTESTATION = { hasAttestationVideo: false, isAttestationWaived: false };

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: drawerWidth,
    },
    [theme.breakpoints.down("sm")]: {
      backgroundColor: "#256141",
    },
  },
  footer: {
    paddingTop: "50px",
    width: "100%",
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    //zIndex: "1099",
    //paddingTop: "75px",
    backgroundColor: "#256141",
    width: drawerWidth,
  },
  drawerPaperMobile: {
    backgroundColor: "#256141",
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    fontFamily: "Gill Sans, Poppins",
    background: "white",
    height: "100%",
    width: "100%",
  },
  brand: {
    width: "170px",
    height: "auto",
    display: "flex",
    marginLeft: "35px",
    alignItems: "center",
    justifyContent: "center",
  },
  brand2: {
    marginLeft: "40px",
    marginTop: "10px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  logoMobile: {
    height: "auto",
    width: "200px",
    marginLeft: "-25px",
    marginTop: "5px",
  },
  iconColor: {
    color: "#246040",
    [theme.breakpoints.down("sm")]: {
      color: "white",
    },
  },
  align_right: {
    position: "absolute",
    right: "25px",
  },
  root_fab: {
    height: 0,
    flexGrow: 1,
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    color: "white",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  button: {
    color: theme.palette.getContrastText(orange[900]),
    backgroundColor: "#C8932A",
    fontFamily: "Gill Sans, Poppins",
    fontSize: "13px",
    padding: "10px 30px",
    "&:hover": {
      backgroundColor: "#b8892e",
    },
    // [theme.breakpoints.down("sm")]: {
    //   display: "none",
    // },
  },
  mainContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: "100vh",
    overflow: "hidden",
    position: "relative",
  },

  bottomAppBar: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: drawerWidth,
    },
    [theme.breakpoints.down("sm")]: {
      backgroundColor: "#256141",
    },
  },
}));

function ResponsiveDrawer(props) {
  const authUser = React.useContext(AuthUserContext);
  const attestationAccount = useAttestationEligibility(props.firebase, authUser?.uid, "video-only");
  const kycAttestation = useKycAttestation(props.firebase, authUser?.uid);
  const location = useLocation();
  const fundEligibility = useFundEligibility(props.firebase, authUser?.uid, location.pathname,
    attestationAccount.data?.stats?.tier, attestationAccount.data?.stats?.status);
  const browseOnly = attestationAccount.data?.stats?.tier === 1;
  const queryParams = new URLSearchParams(location.search);
  const paymentStep = queryParams.get("step");

  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open_nav = Boolean(anchorEl);

  const [notifEl, setNotifEl] = React.useState(false);

  const [accToggler, setAccToggler] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const smBreakpoint = useMediaQuery(theme.breakpoints.down("sm"));
  const isBelow600 = useMediaQuery("(max-width:599px)");

  const [selectedFund, setSelectedFund] = React.useState(null);
  const investmentSummary = attestationAccount.data?.investmentSummary;
  const disabledInvestment = loading || (selectedFund && !!getInvestmentEligibilityMessage(selectedFund, fundEligibility,
    getApplicableInvestmentMinimum(selectedFund, investmentSummary)));
  const handleAccToggler = () => {
    setAccToggler(!accToggler);
  };

  const handleNotifToggle = () => {
    setNotifEl(!notifEl);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    localStorage.removeItem("fundName");
    localStorage.removeItem("requireValidId");
    localStorage.removeItem("markerValidId");
    props.firebase.doSignOut();
  };

  const accountProfile = () => {
    history.push(ROUTES.ACCOUNT_PROFILE);
  };

  React.useEffect(() => {
    let active = true;
    setSelectedFund(null);
    const fundId = location.pathname.startsWith(`${ROUTES.FUNDS}/`)
      ? decodeURIComponent(location.pathname.slice(ROUTES.FUNDS.length + 1).split("/")[0]) : null;
    if (!fundId || location.pathname.includes("payment")) {
      setLoading(false);
      return () => { active = false; };
    }
    setLoading(true);
    props.firebase.db.collection("funds").doc(fundId).get().then((doc) => {
      if (active) { setSelectedFund(doc.exists ? { ...doc.data(), id: doc.id } : null); setLoading(!doc.exists); }
    }).catch(() => { if (active) setLoading(true); });
    return () => { active = false; };
  }, [props.firebase, location.pathname]);

  const startInvest = () => {
    if (!browseOnly && (fundEligibility.status !== "ready" || fundEligibility.data.remainingAmount <= 0 || disabledInvestment)) return;
    history.push(ROUTES.MY_INVESTMENTS);
  };
  const getVerify = () => {
    history.push(ROUTES.LONG_KYC_LAST);
  };

  const urls = [
    {
      path: ROUTES.DASHBOARD,
      title: "Dashboard",
      icon: <DashboardOutlined />,
    },
    {
      path: "#notifications",
      title: "Notifications",
      icon: <NotificationsOutlinedIcon style={{ color: "white" }} />,
    },
    {
      path: ROUTES.INVESTMENT_HISTORY,
      title: "Investment History",
      icon: <HistoryOutlined />,
    },
    {
      path: ROUTES.RECURRING_INVESTMENT_HISTORY,
      title: "Recurring Investments",
      icon: <Schedule />,
    },
    {
      path: ROUTES.NAVPS,
      title: "Net Asset Value Per Unit",
      icon: <TrendingUpIcon />,
    },
    {
      href: "https://rampver.com/portfolio-builder.html",
      title: "Portfolio Builder",
      icon: <PieChartOutlined />,
    },
    {
      path: ROUTES.FAQS,
      title: "Frequently Asked Questions",
      icon: <HelpOutlineOutlinedIcon />,
    },
    {
      path: "#account",
      title: "Account",
      icon: <AccountCircleOutlinedIcon style={{ color: "white" }} />,
    },
  ];

  const drawer = (
    <div>
      <img className={classes.brand} src={Logo} alt="rampver-logo" />
      {props.sidebarContent ? (
        props.sidebarContent
      ) : (
      <List className="custom-nav-links">
        {urls.map((url, index) => {
          if (url.path === "#notifications") {
            return (
              <ListItem onClick={handleNotifToggle} key={index}>
                <ListItemIcon>{url.icon}</ListItemIcon>
                <ListItemText primary={url.title} style={{ color: "white" }} />
              </ListItem>
            );
          } else if (url.path === "#account") {
            return (
              <React.Fragment key={index}>
                <ListItem onClick={handleAccToggler}>
                  <ListItemIcon>{url.icon}</ListItemIcon>
                  <ListItemText
                    primary={url.title}
                    style={{ color: "white" }}
                  />
                  {accToggler ? (
                    <ExpandLess style={{ color: "white" }} />
                  ) : (
                    <ExpandMore style={{ color: "white" }} />
                  )}
                </ListItem>
                <Collapse in={accToggler} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem className={classes.nested}>
                      <NavLink
                        style={{ marginLeft: 20, color: "#000" }}
                        to={ROUTES.ACCOUNT_PROFILE}
                      >
                        <span>Profile</span>
                      </NavLink>
                    </ListItem>
                    <ListItem onClick={logout} className={classes.nested}>
                      <NavLink
                        style={{ marginLeft: 20, color: "#000" }}
                        to="#logout"
                      >
                        <span>Logout</span>
                      </NavLink>
                    </ListItem>
                  </List>
                </Collapse>
              </React.Fragment>
            );
          } else if (url.href) {
            return (
              <ListItem key={index}>
                <a href={url.href} target="_blank" rel="noopener noreferrer">
                  {url.icon}
                  <span>{url.title}</span>
                </a>
              </ListItem>
            );
          } else {
            return (
              <ListItem key={index}>
                <NavLink to={url.path}>
                  {url.icon}
                  <span>{url.title}</span>
                </NavLink>
              </ListItem>
            );
          }
        })}
      </List>
      )}
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const tier = attestationAccount.data?.stats?.tier;
  const kycStatus = attestationAccount.status;
  const isAwaitingAttestation = kycStatus === "LONG_KYC-6";
  const isLongKycReturned = kycStatus === "LONG_KYC-3";
  const isLongKycDeclined = kycStatus === "LONG_KYC-4";
  const isLongKycPending = LONG_KYC_PENDING_STATUSES.includes(kycStatus);
  const hasAttestationVideo =
    attestationAccount.data?.attestationVideoUploaded === true || kycAttestation.hasAttestationVideo;
  // Only legacy Long KYC clients reach Zoom verification without a video; the current form requires one.
  const needsLegacyAttestationVideo =
    isAwaitingAttestation && !hasAttestationVideo && !kycAttestation.isAttestationWaived;
  const showAttestationBanner = isAwaitingAttestation || isLongKycReturned;
  const showAttestationCta = attestationAccount.eligible && needsLegacyAttestationVideo;
  const spacing = tier === 2 ? "mt-14" : "";

  const isTier2AndValidated =
    tier === 2 && (isLongKycPending || isLongKycDeclined);
  const isFullyVerified =
    fundEligibility.status === "ready" && fundEligibility.data.tier === 2 && fundEligibility.data.remainingAmount <= 0;
  const canInvest = fundEligibility.status === "ready" && fundEligibility.data.remainingAmount > 0;

  const isPaymentLocation = location.pathname.includes("payment");
  const isAttestationLocation = location.pathname === ROUTES.VIDEO_ATTESTATION;
  let paymentDisplayText = "";

  switch (paymentStep) {
    case "2":
      paymentDisplayText =
        "Choose a Payment Option and follow the instructions";
      break;

    case "3":
      paymentDisplayText = "Don't forget to upload your proof of transfer";
      break;

    case "1":
    default:
      paymentDisplayText = "Enter Amount to be invested";
      break;
  }
  const isInvestementPath = location.pathname === ROUTES.MY_INVESTMENTS;
  const segments = location.pathname.split("/");

  return (
    <div className={`flex mt${spacing}`}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar} color="inherit">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon style={{ color: "white" }} />
          </IconButton>
          <div>
            <img
              className={classes.logoMobile}
              src={LogoMobile}
              alt="rampver-logo"
            />
          </div>

          <div className={classes.align_right}>
            {!isInvestementPath && segments.pop() !== `payment` && segments.pop() !== `funds` && (
              <>
                {isFullyVerified || disabledInvestment ? (
                  <Tooltip
                    title="Get Fully Verified Now!"
                    arrow
                    placement="bottom"
                  >
                    <span>
                      <Button disabled variant="contained" className={classes.button}>
                        Invest Now
                      </Button>
                    </span>
                  </Tooltip>
                ) : (
                  !loading && (
                    <Button
                      variant="contained"
                      className={classes.button}
                      style={{ display: isBelow600 && "none" }}
                      onClick={startInvest}
                      disabled={!browseOnly && (!canInvest || disabledInvestment)}
                    >
                      {browseOnly ? "Learn More" : "Invest Now"}
                    </Button>
                  )
                )}
              </>
            )}

            <IconButton>
              <NotificationMenu toggle={notifEl} theme={smBreakpoint} />
            </IconButton>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircleOutlinedIcon className={classes.iconColor} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={open_nav}
              onClose={handleClose}
            >
              <MenuItem onClick={accountProfile}>Account Profile</MenuItem>
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      {tier === 2 && !isPaymentLocation && !isAttestationLocation && (
        <AppBar
          position="fixed"
          style={{
            backgroundColor: showAttestationCta
              ? "rgba(59, 130, 246, 1)"
              : COLOR_PRIMARY,
            height: "auto",
            top: "75px",
            zIndex: 1000,
          }}
        >
          <Toolbar>
            {showAttestationBanner ? (
              <>
                <div className="flex justify-center align-middle mr-36 py-3 lg:py-0 smd:ml-64 sm:ml-64 md:ml-56 lg:ml-64 w-auto lg:w-auto text-sm lg:text-lg font-medium font-poppins text-white">
                  {isLongKycReturned
                    ? "Your updated application is being reviewed."
                    : needsLegacyAttestationVideo
                    ? "Complete your verification by uploading a video attestation."
                    : kycAttestation.isAttestationWaived
                    ? "Your video attestation has been waived. Your application is being processed."
                    : "Your application is being processed."}
                </div>
                {showAttestationCta && (
                  <div className={classes.align_right}>
                    <Button
                      variant="contained"
                      className={classes.button}
                      onClick={() => history.push(ROUTES.VIDEO_ATTESTATION)}
                    >
                      Record Video
                    </Button>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="flex justify-center align-middle mr-36 py-3 lg:py-0 smd:ml-64 sm:ml-64 md:ml-56 lg:ml-64 w-auto lg:w-auto text-sm lg:text-lg font-medium font-poppins">
                  You are now able to invest up to P50,000! Want to enjoy the
                  complete Rampver Online experience? Get fully verified today!
                </div>
                <div className={classes.align_right}>
                  {isLongKycDeclined ? (
                    <Button
                      variant="contained"
                      className={classes.button}
                      onClick={() => history.push(ROUTES.DECLINEDUPGRADE_PAGE)}
                    >
                      Declined
                    </Button>
                  ) : isLongKycPending ? (
                    <Button variant="contained" disabled className={classes.button}>
                      Processing
                    </Button>
                  ) : (
                    <a
                      onClick={getVerify}
                      className="flex justify-center align-middle text-center w-20 lg:w-auto p-2 lg:m-5 text-sm rounded bg-primary lg:text-base capitalize text-white lg:whitespace-nowrap"
                      style={{ fontFamily: "Gill Sans, Poppins" }}
                    >
                      Get Fully Verified
                    </a>
                  )}
                </div>
              </>
            )}
          </Toolbar>
        </AppBar>
      )}
      {isPaymentLocation && (
        <AppBar
          position="fixed"
          style={{
            backgroundColor: COLOR_PRIMARY,
            height: "fit-content",
            top: "75px",
            zIndex: 1000,
          }}
        >
          <div className="flex justify-center align-middle px-3 py-3 lg:py-0 lg:ml-64 w-52 lg:w-auto text-sm lg:text-lg font-medium font-poppins my-4 w-full">
            {paymentDisplayText}
          </div>
        </AppBar>
      )}
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaperMobile,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <div
        className={classes.mainContent}
        style={
          tier === 2 && !isAttestationLocation
            ? { marginTop: "60px" }
            : { marginTop: "0px" }
        }
      >
        <main className={classes.content} color="inherit">
          <div className={classes.toolbar} />
          {React.isValidElement(props.content)
            ? React.cloneElement(props.content, { fundEligibility, investmentSummary }) : props.content}
        </main>
        <footer className={classes.footer}>
          <Footer isSignIn={false} />
        </footer>
        {props.disableFab || loading ? (
          ""
        ) : (
          <div className={classes.root_fab}>
            {isFullyVerified || disabledInvestment ? (
              <Fab
                variant="extended"
                aria-label="InvestBtn"
                className={classes.fab}
                color="primary"
                onClick={getVerify}
                style={{ whiteSpace: "nowrap" }}
              >
                Get Fully Verified!
              </Fab>
            ) : !isInvestementPath ? (
              isTier2AndValidated ? (
                <Fab
                  variant="extended"
                  aria-label="InvestBtn"
                  className={classes.fab}
                  color="primary"
                  onClick={startInvest}
                  disabled={!canInvest || disabledInvestment}
                >
                  Invest Now
                </Fab>
              ) : (
                <Fab
                  variant="extended"
                  aria-label="InvestBtn"
                  className={classes.fab}
                  color="primary"
                  onClick={startInvest}
                  disabled={!browseOnly && (!canInvest || disabledInvestment)}
                >
                  {canInvest ? `Invest Now` : `Learn More`}
                </Fab>
              )
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function useKycAttestation(firebase, uid) {
  const [kycAttestation, setKycAttestation] = React.useState(EMPTY_KYC_ATTESTATION);

  React.useEffect(() => {
    setKycAttestation(EMPTY_KYC_ATTESTATION);
    if (!firebase || !uid) return undefined;
    return firebase.db.collection("users").doc(uid).collection("KYC").doc("KYC").onSnapshot(
      (snapshot) => {
        const kyc = snapshot.data();
        setKycAttestation({
          hasAttestationVideo: Boolean(kyc?.attestationVideo),
          isAttestationWaived: kyc?.attestationVideoExcluded === true,
        });
      },
      () => setKycAttestation(EMPTY_KYC_ATTESTATION)
    );
  }, [firebase, uid]);

  return kycAttestation;
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
  sidebarContent: PropTypes.node,
};

export default withFirebase(ResponsiveDrawer);
